import { Box } from '@mui/material';
import React, { useEffect } from 'react';
import { MFSubmitButton } from '../../lib/formik';
import { useHistory } from 'react-router-dom';
import * as yup from 'yup';
import { Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationProps } from '../../redux-store/types/api-types';
import { Location } from 'history';
import {
  getFlowTypeNote,
  getFundSelectionNote,
  IsInvestorWithPAN,
} from '../../utils/utilityFunctions';
import { FLOW_TYPE_MASTER, FUND_FLOW_TYPE_MASTER } from '../../utils/constant';
import UseRadioGroup from '../../lib/formik/Radio';
import { useSnackbar } from 'notistack';
import { RootStateType } from '../../redux-store/reducers';
import { Notes } from '../investors/components';
import { FundProps, GetFundsListResponseBody } from '../../redux-store/types/funds';
import { getFundsList } from '../../redux-store/actions/funds';

interface Values {
  flowType: string;
  fundFlowType: string;
}

export default function Onboard({
  location,
}: {
  location: Location<{
    firstHolderName: string;
    application: ApplicationProps;
    redirectTo: string;
  }>;
}): JSX.Element {
  const { application } = location.state || {};
  const { applicants = [] } = application || {};
  const history = useHistory();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const [fundData, setFundData] = React.useState<FundProps[]>([]);

  useEffect(() => {
    let isComponentActive = true;
    (async () => {
      try {
        const res = (await dispatch(
          getFundsList({ isActive: true })
        )) as unknown as GetFundsListResponseBody;
        if (!isComponentActive) return;
        setFundData(res.funds || []);
      } catch (e) {
        console.log((e as Error).message);
      }
    })();
    return () => {
      isComponentActive = false;
    };
  }, []);

  const validationSchema1 = yup.object().shape({
    flowType: yup
      .string()
      .nullable()
      .required('Flow Type is required')
      .when('fundFlowType', (fundFlowType, schema) =>
        fundFlowType
          ? schema.oneOf(
              Object.keys(FLOW_TYPE_MASTER).filter((flow) =>
                FUND_FLOW_TYPE_MASTER.outbound == FUND_FLOW_TYPE_MASTER[fundFlowType] &&
                FLOW_TYPE_MASTER.investor_without_pan == FLOW_TYPE_MASTER[flow]
                  ? false
                  : true
              ),
              'Flow Type is required'
            )
          : schema
      ),
    fundFlowType: yup.string().nullable().required('Onboarding Flow Type is required'),
  });
  const initialValues: Values = {
    flowType: '',
    fundFlowType: '',
  };

  const handleSubmit1 = async (values: Values) => {
    try {
      const { flowType = '' } = values;
      const locationHistory = {
        ...(values || {}),
        redirectTo: 'start',
      };
      return history.push(
        IsInvestorWithPAN(flowType) ? `enter-pan-number` : 'enter-tax-id-number',
        locationHistory
      );
    } catch (e) {
      console.error((e as Error).message);
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema1}
      enableReinitialize={true}
      onSubmit={handleSubmit1}>
      {({ handleSubmit, values }) => {
        const noteContent = getFlowTypeNote(values.fundFlowType, fundData);
        const investorTypeNote = getFundSelectionNote(values.fundFlowType);

        return (
          <>
            <Box component="form" noValidate onSubmit={handleSubmit}>
              <Box sx={{ mt: 1.5 }}>
                <UseRadioGroup
                  formLabel="Onboarding Flow Type"
                  name={`fundFlowType`}
                  items={Object.keys(FUND_FLOW_TYPE_MASTER).map((option) => ({
                    label: FUND_FLOW_TYPE_MASTER[option],
                    value: option,
                  }))}
                />
              </Box>
              <Box sx={{ mt: 1.5 }}>
                <UseRadioGroup
                  formLabel="Flow Type"
                  name={`flowType`}
                  items={Object.keys(FLOW_TYPE_MASTER)
                    .filter((flow) =>
                      FUND_FLOW_TYPE_MASTER.outbound ==
                        FUND_FLOW_TYPE_MASTER[values.fundFlowType] &&
                      FLOW_TYPE_MASTER.investor_without_pan == FLOW_TYPE_MASTER[flow]
                        ? false
                        : true
                    )
                    .map((option) => ({
                      label: FLOW_TYPE_MASTER[option],
                      value: option,
                    }))}
                />
              </Box>
              {noteContent && (
                <Notes
                  displayContent="Applicable fund:"
                  displayContent1={noteContent}
                  sx={{ backgroundColor: '#fffbe5', boxShadow: 2 }}
                />
              )}
              {investorTypeNote && (
                <Notes
                  displayContent="Note:"
                  displayContent1={investorTypeNote}
                  sx={{ backgroundColor: '#fffbe5', boxShadow: 2 }}
                />
              )}
              <MFSubmitButton label="Proceed" />
            </Box>
          </>
        );
      }}
    </Formik>
  );
}
